import React, { useState, useEffect} from "react";
import './About.css';

import banner1 from '../assets/images/Slides/gallery01.jpg';
import banner2 from '../assets/images/Slides/gallery05.jpg';
import banner3 from '../assets/images/Slides/gallery09.jpg';
import banner4 from '../assets/images/Slides/gallery14.jpg';
import banner5 from '../assets/images/Slides/gallery17.jpg';
import banner6 from '../assets/images/Slides/gallery19.jpg';

import banner7 from '../assets/images/Slides/gallery20.jpg';
import banner8 from '../assets/images/Slides/gallery21.jpg';

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const images = [
    banner1,
    banner2,
    banner3,
    banner4,
    banner5,
    banner6,
    banner7,
    banner8
  ];


const About = () => {
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    
    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 600);
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);

    }, []);

    return(
        <>
            <section className="about" id="about">
                <div className="about-div">
                    <h3>Wer wir Sind</h3>
                    <h2>Experten für Tankreinigung</h2>
                    <div>
                        Die Delta Tank GmbH ist führend in der Bereitstellung erstklassiger Tankreinigungs- und leichter Korrosionsschutzdienste in Dortmund. 
                        Unser engagiertes Team nutzt fortschrittliche Technologien und bewährte Branchenpraktiken, um optimale Ergebnisse zu gewährleisten. 
                        Wir legen großen Wert auf Sicherheit, Effizienz und Kundenzufriedenheit bei jedem Projekt, was uns zur bevorzugten Wahl für Unternehmen macht, 
                        die zuverlässige Tankwartungslösungen suchen
                    </div>
                </div>
                <div className="silder">
                    <Slider {...settings} style={{width: isSmallScreen ? '350px':'500px', margin: 'auto'}} >
                        {images.map((src, index) => (
                            <div key={index}>
                            <img 
                                src={src} 
                                alt={`Slide ${index}`} 
                                style={{ 
                                    width: '100%',
                                    height: 'auto',
                                    maxHeight: isSmallScreen  ? '200px':'300px',
                                    objectFit: 'cover'
                                }} 
                            />
                            </div>
                        ))}
                    </Slider>
                </div>
                {/*<img src={require("../assets/images/merged.jpg")} width={'500px'}></img>*/}
            </section>
        </>
    );
};

export default About;